import {UI} from "../../../../stem-core/ui/UIBase.js";
import {styleRule, registerStyle, StyleSheet} from "../../../../stem-core/ui/Style.js";
import {Router} from "../../../../stem-core/ui/Router.jsx";
import {FormContainerPage} from "../../../common/FormContainerPage.jsx";
import {authService} from "../../../../client/connection/services/AuthService.js";
import {Messages} from "../../../Messages.js";
import {AuthHelper} from "../../../AuthHelper.js";
import {getQueryParam} from "../../../UtilsLib.js";
import type {UIChild} from "../../../../stem-core/ui/UIBase";


class LoginByEmailCodeUrlPageStyle extends StyleSheet {
    @styleRule
    text = {
        textAlign: "center",
        marginTop: 32,
    };
}

interface LoginByEmailCodeUrlClassOptions {
    text?: UIChild;
}

@registerStyle(LoginByEmailCodeUrlPageStyle)
class LoginByEmailCodeUrlClass extends UI.Element<LoginByEmailCodeUrlClassOptions> {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            text: Messages.loggingInByEmailKey,
        };
    }

    onRequestSuccess(redirectUrl: string) {
        this.updateOptions({text: Messages.redirectingToInitialPage});
        setTimeout(() => AuthHelper.completedLoginByEmailKeyAction(redirectUrl), 500);
    }

    onRequestError(error: {message: string}) {
        this.updateOptions({text: error.message});
    }

    render() {
        return <div className={this.styleSheet.text}>{this.options.text}</div>;
    }

    async onMount() {
        super.onMount();

        const redirectUrl = getQueryParam("redirectUrl");
        if (authService.isAuthenticated()) {
            this.onRequestSuccess(redirectUrl);
            return;
        }

        try {
            const response = await authService.loginWithEmailCode({uuid: Router.parseURL()[2]});
            this.onRequestSuccess(redirectUrl || response.redirectUrl);
        } catch (error) {
            this.onRequestError(error);
        }
    }
}

export const LoginByEmailCodeUrlPage = FormContainerPage(LoginByEmailCodeUrlClass);
